<!-- @format -->

<ng-container *transloco="let t">
  @if (
    {
      isMobileView: isMobileView$ | async,
      parameters: searchService.searchParameters$ | async,
      searchFilterCount: searchFilterCount$ | async,
    };
    as context
  ) {
    <div class="row align-items-baseline">
      @if (context.parameters?.filters?.universityOrgId | organisation | async; as university) {
        <div class="col-lg-2">
          <label id="university-select-editor-label">{{ t("SEARCH.UNIVERSITY_LABEL") }}</label>
          <sis-university-select-editor
            [ariaLabelledBy]="'university-select-editor-label'"
            [placeOnLeft]="true"
            [onlySisuOrganisations]="true"
            [university]="university"
            (universityChange)="selectUniversity($event?.id)">
          </sis-university-select-editor>
        </div>
      }
      @if (isTextSearchEnabled) {
        <div [ngClass]="getTextSearchInputContainerClass(context.parameters)">
          <label for="full-text-query-input">{{ t("SEARCH.INPUT_LABEL") }}</label>
          <div class="search-group">
            <input
              #fullTextQueryInput
              id="full-text-query-input"
              data-cy="full-text-query-input"
              class="fudis-form-input fudis-text-input__input"
              [value]="context.parameters?.filters?.fullTextQuery || ''"
              (keyup.enter)="searchButtonTriggered()"
              [attr.aria-invalid]="!!errorMessage || !!searchResult?.truncated || searchResult?.total === 0"
              [attr.aria-describedby]="'search-guidance-' + id" />
            <sis-button
              class="search-trigger-button"
              [dataCy]="'search-trigger-button'"
              [ariaLabel]="t(ariaLabel)"
              (clicked)="searchButtonTriggered()"
              [ngClass]="'btn-search'">
              <sis-icon color="white" icon="search" aria-hidden="true" />
              {{ t("SEARCH.PLACEHOLDER_SEARCH") }}
            </sis-button>
          </div>
          <div class="fudis-guidance">
            <div id="search-guidance-{{ id }}">
              <div aria-atomic="true" aria-live="polite" class="fudis-guidance__errors" data-cy="search-query-notifications">
                @if (customErrorMessage || searchResult?.total === 0 || errorMessage || searchResult?.truncated) {
                  <span class="fudis-icon fudis-icon__color__red fudis-icon__lg fudis-icon__alert"></span>
                }
                @if (errorMessage) {
                  <div class="fudis-guidance__errors__list">
                    <p class="fudis-error-message fudis-error-message__form-error">
                      {{ t(errorMessage, { count: difference }) }}
                    </p>
                  </div>
                } @else if (customErrorMessage) {
                  <div class="fudis-guidance__errors__list">
                    <p class="fudis-error-message fudis-error-message__form-error">
                      {{ customErrorMessage }}
                    </p>
                  </div>
                } @else if (searchResult?.truncated) {
                  <div class="fudis-guidance__errors__list">
                    <p class="fudis-error-message fudis-error-message__form-error">
                      {{ t("SEARCH_RESULTS.RESULTS_TRUNCATED") }}
                    </p>
                  </div>
                } @else if (searchResult?.total === 0) {
                  <div class="fudis-guidance__errors__list">
                    <p class="fudis-error-message fudis-error-message__form-error">
                      {{ t("SEARCH_RESULTS.ZERO_RESULTS") }}
                    </p>
                  </div>
                } @else {
                  <p class="fudis-visually-hidden">
                    @if (searchResult?.total === 1) {
                      <span>{{ t("SEARCH_RESULTS.ONE_RESULT") }}</span>
                    } @else if (searchResult?.total <= searchResult?.limit) {
                      <span>
                        {{ t("SEARCH_RESULTS.ALL_RESULTS_SHOWN", { count: searchResult?.total }) }}
                      </span>
                    } @else {
                      <span>
                        {{
                          t("SEARCH_RESULTS.ALL_RESULTS_NOT_SHOWN", {
                            totalCount: searchResult?.total,
                            count: searchResult?.limit,
                          })
                        }}
                      </span>
                      @if (searchResult.total >= MAX_SEARCH_LIMIT && searchResult.limit >= MAX_SEARCH_LIMIT) {
                        <span>{{ t("SEARCH_RESULTS.TOO_MANY_RESULTS") }}</span>
                      }
                    }
                  </p>
                }
              </div>
              <p class="fudis-guidance__help-text">{{ t(guidance) }}</p>
            </div>
          </div>
        </div>
      }
    </div>
    @if (searchFilterTemplates?.length > 0) {
      <sis-expandable
        [variant]="'link'"
        [title]="searchFiltersTitle(context.searchFilterCount)"
        [closed]="context.isMobileView || !areSearchFiltersAllowed"
        [disabled]="!areSearchFiltersAllowed"
        [closed]="closedByDefault"
        data-cy="search-filters-expandable">
        <ng-template sisExpandableContent>
          <div class="row search-filter-row align-items-baseline">
            @for (template of searchFilterTemplates; track $index) {
              @if (template.subtitle) {
                <fudis-heading [level]="subtitleLevel" [class]="'fudis-mt-md fudis-mb-md'">{{ template.subtitle }}</fudis-heading>
              }
              @if (template?.singleFilterComponent) {
                <div class="col-lg-6 fudis-mb-sm">
                  <ng-container [ngTemplateOutlet]="template?.templateRef"></ng-container>
                </div>
              } @else {
                <div class="col-lg-3 fudis-mb-sm">
                  <ng-container [ngTemplateOutlet]="template?.templateRef"></ng-container>
                </div>
              }
            }
          </div>
          @if (context.searchFilterCount > 0) {
            <fudis-button
              (handleClick)="clearSearchFilters(context?.parameters)"
              [label]="t('SEARCH.CLEAR_SEARCH_FILTERS')"
              [variant]="'tertiary'"
              [icon]="'close'"
              data-cy="clear-search-filters-button"
              [class]="'fudis-mt-md fudis-mb-md'" />
          }
        </ng-template>
      </sis-expandable>
    }
  }
</ng-container>
